import React, { useState, useLayoutEffect, useContext } from 'react';

import * as S from './styles';
import SimpleInput from 'components/SimpleInput';
import Check from 'components/Buttons/Check';
import { formatDateToISO, formatToDateCustom } from 'utils/functions';
import DynamicPageContext from 'context/DynamicPage';
import { verifyIfFormCanSave } from './functions';
import { optionsWeightFont } from 'utils/optionsInputs';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import SelectInput from 'components/SelectInput';

export interface DataInputsDescriptionTextProps {
	name: string;
	description: string;
	countdown: boolean;
	schedule_start: string;
	schedule_end: string;
	reference_id: string;
}

const initialState: DataInputsDescriptionTextProps = {
	name: '',
	description: '',
	countdown: false,
	schedule_start: '',
	schedule_end: '',
	reference_id: ''
};

export default function InputsDescriptionText() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [dataForm, setDataForm] =
		useState<DataInputsDescriptionTextProps>(initialState);
	const [isShowDateInputs, setIsShowDateInputs] = useState(false);

	function findeOptionOnListByNumber(value: string) {
		const itemsList = optionsWeightFont.filter((item) => item.option === value);
		if (itemsList.length > 0) {
			return itemsList[0];
		}

		return '';
	}

	//reseta os dados de agendamento os inputs não estejam visiaveis
	useLayoutEffect(() => {
		if (!isShowDateInputs) {
			setDataForm((obj) => ({
				...obj,
				schedule_end: '',
				countdown: false,
				schedule_start: ''
			}));
		}
	}, [isShowDateInputs]);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(dataForm, setCanSaveModuleOnBack, setMessageErrorForm);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);

			if (
				moduleOnPhoneToEdit?.data?.schedule_start !== '' ||
				moduleOnPhoneToEdit?.data?.schedule_end !== ''
			) {
				setIsShowDateInputs(true);
			}
		}
	}, []);

	return (
		<S.container>
			<S.twoInputs>
				<SimpleInput
					label="Título"
					initialValue={dataForm.name}
					getValue={(value: string) => {
						setDataForm((obj) => ({ ...obj, name: value }));
					}}
				/>

				<SelectInput
					list={optionsWeightFont}
					getValue={(value: SelectInputItemProps | '') => {
						setDataForm((obj) => ({
							...obj,
							reference_id: value === '' ? value : value?.option
						}));
					}}
					initialValue={findeOptionOnListByNumber(dataForm.reference_id)}
					label="Peso da fonte"
				/>
			</S.twoInputs>

			<SimpleInput
				label="Descrição"
				initialValue={dataForm.description}
				getValue={(value: string) => {
					setDataForm((obj) => ({ ...obj, description: value }));
				}}
			/>

			<div style={{ display: 'none' }}>
				<Check
					text="Programação"
					isChecked={isShowDateInputs}
					setIsChecked={() => {
						setIsShowDateInputs((obj) => !obj);
					}}
				/>

				{isShowDateInputs && (
					<>
						<S.inputsDate>
							<SimpleInput
								typeInput="datetime-local"
								label="Fim"
								initialValue={
									dataForm.schedule_start === ''
										? ''
										: formatToDateCustom(dataForm.schedule_start)
								}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										schedule_start: formatDateToISO(value)
									}));
								}}
								paddingInLineEnd
							/>

							<SimpleInput
								typeInput="datetime-local"
								label="Fim"
								initialValue={
									dataForm.schedule_end === ''
										? ''
										: formatToDateCustom(dataForm.schedule_end)
								}
								getValue={(value: string) => {
									setDataForm((obj) => ({
										...obj,
										schedule_end: formatDateToISO(value)
									}));
								}}
								paddingInLineEnd
							/>
						</S.inputsDate>

						<Check
							text="Contagem regressiva"
							isChecked={dataForm.countdown}
							setIsChecked={() => {
								setDataForm((obj) => ({
									...obj,
									countdown: !obj.countdown
								}));
							}}
						/>
					</>
				)}
			</div>
		</S.container>
	);
}
